var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.625.922-.005 4.781a.422.422 0 0 1-.422.422h-.976a.422.422 0 0 1-.422-.43l.08-2.157-.06-.06-8.17 8.169a.352.352 0 0 1-.497 0l-.675-.675a.352.352 0 0 1 0-.497l8.17-8.17-.06-.06-2.158.08a.422.422 0 0 1-.43-.422V.927c0-.233.189-.422.422-.422L17.203.5c.233 0 .422.189.422.422Zm-4.35 6.426-.703.703a.352.352 0 0 0-.103.249v5.618a.176.176 0 0 1-.176.176H2.332a.176.176 0 0 1-.176-.176V3.957a.176.176 0 0 1 .176-.176h8.847c.313 0 .47-.378.249-.6l-.704-.703a.351.351 0 0 0-.248-.103h-8.32c-.776 0-1.406.63-1.406 1.406v10.313c0 .776.63 1.406 1.406 1.406H12.47c.776 0 1.406-.63 1.406-1.406V7.596a.352.352 0 0 0-.6-.248Z",
    fill: "#000"
  })));
};

export default SvgExternal;